// extracted by mini-css-extract-plugin
module.exports = {"Default":"Quote__Default_3sM_i","Big":"Quote__Big_8IzaH Quote__Default_3sM_i","Small":"Quote__Small_2fGxB Quote__Default_3sM_i"};